import {Component, Input, OnInit} from '@angular/core';
import {RbbWintersportWetterWerte} from '../../../../../../../../model/messwerte/rbb-wintersport-wetter';
import {take} from 'rxjs/operators';
import {FirebaseService} from '../../../../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-rbb-wintersport-wetter-werte',
  templateUrl: './rbb-wintersport-wetter-werte.component.html',
  styleUrls: ['./rbb-wintersport-wetter-werte.component.css','../wintersport-wetter.component.css']
})
export class RbbWintersportWetterWerteComponent implements OnInit {

  isLoading = false;
  wintersportWetterWerte: RbbWintersportWetterWerte;

  constructor(private firebaseService: FirebaseService, private matSnackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.loadWerte();
  }

  public loadWerte() {
    this.isLoading = true;
    this.firebaseService.getMesswerteMeteoGroupRBBFor('Wintersportwetter_Werte')
      .pipe(take(1))
      .subscribe({
        next: value => this.wintersportWetterWerte = value.data(),
        error: err => this.matSnackBar.open('ERROR loadWerte() ' + err, 'Ok'),
        complete: () => this.isLoading = false
      });
  }

}
